/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProductApplicationUpdateModel } from '../models/product-application-update-model';
import { ProductApplicationUpdateResult } from '../models/product-application-update-result';
import { ProductCheckoutUpdateRequest } from '../models/product-checkout-update-request';
import { ProductCheckoutUpdateResponse } from '../models/product-checkout-update-response';
import { ProductCreateModel } from '../models/product-create-model';
import { ProductCreateResult } from '../models/product-create-result';
import { ProductGetListRequest } from '../models/product-get-list-request';
import { ProductGetListResponse } from '../models/product-get-list-response';
import { ProductGetResponse } from '../models/product-get-response';
import { ProductStatusUpdateRequest } from '../models/product-status-update-request';
import { ProductStatusUpdateResponse } from '../models/product-status-update-response';
import { ProductThemeUpdateRequest } from '../models/product-theme-update-request';
import { ProductThemeUpdateResponse } from '../models/product-theme-update-response';
import { ProductToggleCountryRequest } from '../models/product-toggle-country-request';
import { ProductToggleCountryResponse } from '../models/product-toggle-country-response';
import { ProductUpdateModel } from '../models/product-update-model';
import { ProductUpdateResult } from '../models/product-update-result';

@Injectable({
  providedIn: 'root',
})
export class IndexService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation v1ProductIdGet
   */
  static readonly V1ProductIdGetPath = '/v1/{productId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ProductIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1ProductIdGet$Plain$Response(params: {
    productId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ProductIdGetPath, 'get');
    if (params) {
      rb.path('productId', params.productId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ProductIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1ProductIdGet$Plain(params: {
    productId: string;
  },
  context?: HttpContext

): Observable<ProductGetResponse> {

    return this.v1ProductIdGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductGetResponse>) => r.body as ProductGetResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ProductIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1ProductIdGet$Json$Response(params: {
    productId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductGetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ProductIdGetPath, 'get');
    if (params) {
      rb.path('productId', params.productId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductGetResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ProductIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1ProductIdGet$Json(params: {
    productId: string;
  },
  context?: HttpContext

): Observable<ProductGetResponse> {

    return this.v1ProductIdGet$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductGetResponse>) => r.body as ProductGetResponse)
    );
  }

  /**
   * Path part for operation v1ManageProductsGet
   */
  static readonly V1ManageProductsGetPath = '/v1/manage/products';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ManageProductsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1ManageProductsGet$Plain$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductGetListResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ManageProductsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductGetListResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ManageProductsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1ManageProductsGet$Plain(params?: {
  },
  context?: HttpContext

): Observable<ProductGetListResponse> {

    return this.v1ManageProductsGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductGetListResponse>) => r.body as ProductGetListResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ManageProductsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1ManageProductsGet$Json$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductGetListResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ManageProductsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductGetListResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ManageProductsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v1ManageProductsGet$Json(params?: {
  },
  context?: HttpContext

): Observable<ProductGetListResponse> {

    return this.v1ManageProductsGet$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductGetListResponse>) => r.body as ProductGetListResponse)
    );
  }

  /**
   * Path part for operation v1ManageProductsPost
   */
  static readonly V1ManageProductsPostPath = '/v1/manage/products';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ManageProductsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductsPost$Plain$Response(params?: {
    body?: ProductGetListRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductGetListResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ManageProductsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductGetListResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ManageProductsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductsPost$Plain(params?: {
    body?: ProductGetListRequest
  },
  context?: HttpContext

): Observable<ProductGetListResponse> {

    return this.v1ManageProductsPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductGetListResponse>) => r.body as ProductGetListResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ManageProductsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductsPost$Json$Response(params?: {
    body?: ProductGetListRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductGetListResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ManageProductsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductGetListResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ManageProductsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductsPost$Json(params?: {
    body?: ProductGetListRequest
  },
  context?: HttpContext

): Observable<ProductGetListResponse> {

    return this.v1ManageProductsPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductGetListResponse>) => r.body as ProductGetListResponse)
    );
  }

  /**
   * Path part for operation v1ManageProductThemeUpdatePost
   */
  static readonly V1ManageProductThemeUpdatePostPath = '/v1/manage/product/theme/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ManageProductThemeUpdatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductThemeUpdatePost$Plain$Response(params?: {
    body?: ProductThemeUpdateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductThemeUpdateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ManageProductThemeUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductThemeUpdateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ManageProductThemeUpdatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductThemeUpdatePost$Plain(params?: {
    body?: ProductThemeUpdateRequest
  },
  context?: HttpContext

): Observable<ProductThemeUpdateResponse> {

    return this.v1ManageProductThemeUpdatePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductThemeUpdateResponse>) => r.body as ProductThemeUpdateResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ManageProductThemeUpdatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductThemeUpdatePost$Json$Response(params?: {
    body?: ProductThemeUpdateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductThemeUpdateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ManageProductThemeUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductThemeUpdateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ManageProductThemeUpdatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductThemeUpdatePost$Json(params?: {
    body?: ProductThemeUpdateRequest
  },
  context?: HttpContext

): Observable<ProductThemeUpdateResponse> {

    return this.v1ManageProductThemeUpdatePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductThemeUpdateResponse>) => r.body as ProductThemeUpdateResponse)
    );
  }

  /**
   * Path part for operation v1ManageProductCheckoutUpdatePost
   */
  static readonly V1ManageProductCheckoutUpdatePostPath = '/v1/manage/product/checkout/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ManageProductCheckoutUpdatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductCheckoutUpdatePost$Plain$Response(params?: {
    body?: ProductCheckoutUpdateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductCheckoutUpdateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ManageProductCheckoutUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductCheckoutUpdateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ManageProductCheckoutUpdatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductCheckoutUpdatePost$Plain(params?: {
    body?: ProductCheckoutUpdateRequest
  },
  context?: HttpContext

): Observable<ProductCheckoutUpdateResponse> {

    return this.v1ManageProductCheckoutUpdatePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductCheckoutUpdateResponse>) => r.body as ProductCheckoutUpdateResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ManageProductCheckoutUpdatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductCheckoutUpdatePost$Json$Response(params?: {
    body?: ProductCheckoutUpdateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductCheckoutUpdateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ManageProductCheckoutUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductCheckoutUpdateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ManageProductCheckoutUpdatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductCheckoutUpdatePost$Json(params?: {
    body?: ProductCheckoutUpdateRequest
  },
  context?: HttpContext

): Observable<ProductCheckoutUpdateResponse> {

    return this.v1ManageProductCheckoutUpdatePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductCheckoutUpdateResponse>) => r.body as ProductCheckoutUpdateResponse)
    );
  }

  /**
   * Path part for operation v1ManageProductApplicationUpdatePost
   */
  static readonly V1ManageProductApplicationUpdatePostPath = '/v1/manage/product/application/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ManageProductApplicationUpdatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductApplicationUpdatePost$Plain$Response(params?: {
    body?: ProductApplicationUpdateModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductApplicationUpdateResult>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ManageProductApplicationUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductApplicationUpdateResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ManageProductApplicationUpdatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductApplicationUpdatePost$Plain(params?: {
    body?: ProductApplicationUpdateModel
  },
  context?: HttpContext

): Observable<ProductApplicationUpdateResult> {

    return this.v1ManageProductApplicationUpdatePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductApplicationUpdateResult>) => r.body as ProductApplicationUpdateResult)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ManageProductApplicationUpdatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductApplicationUpdatePost$Json$Response(params?: {
    body?: ProductApplicationUpdateModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductApplicationUpdateResult>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ManageProductApplicationUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductApplicationUpdateResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ManageProductApplicationUpdatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductApplicationUpdatePost$Json(params?: {
    body?: ProductApplicationUpdateModel
  },
  context?: HttpContext

): Observable<ProductApplicationUpdateResult> {

    return this.v1ManageProductApplicationUpdatePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductApplicationUpdateResult>) => r.body as ProductApplicationUpdateResult)
    );
  }

  /**
   * Path part for operation v1ManageProductCountryTogglePost
   */
  static readonly V1ManageProductCountryTogglePostPath = '/v1/manage/product/country/toggle';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ManageProductCountryTogglePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductCountryTogglePost$Plain$Response(params?: {
    body?: ProductToggleCountryRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductToggleCountryResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ManageProductCountryTogglePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductToggleCountryResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ManageProductCountryTogglePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductCountryTogglePost$Plain(params?: {
    body?: ProductToggleCountryRequest
  },
  context?: HttpContext

): Observable<ProductToggleCountryResponse> {

    return this.v1ManageProductCountryTogglePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductToggleCountryResponse>) => r.body as ProductToggleCountryResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ManageProductCountryTogglePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductCountryTogglePost$Json$Response(params?: {
    body?: ProductToggleCountryRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductToggleCountryResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ManageProductCountryTogglePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductToggleCountryResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ManageProductCountryTogglePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageProductCountryTogglePost$Json(params?: {
    body?: ProductToggleCountryRequest
  },
  context?: HttpContext

): Observable<ProductToggleCountryResponse> {

    return this.v1ManageProductCountryTogglePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductToggleCountryResponse>) => r.body as ProductToggleCountryResponse)
    );
  }

  /**
   * Path part for operation v1ManageCreatePost
   */
  static readonly V1ManageCreatePostPath = '/v1/manage/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ManageCreatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageCreatePost$Plain$Response(params?: {
    body?: ProductCreateModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductCreateResult>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ManageCreatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductCreateResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ManageCreatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageCreatePost$Plain(params?: {
    body?: ProductCreateModel
  },
  context?: HttpContext

): Observable<ProductCreateResult> {

    return this.v1ManageCreatePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductCreateResult>) => r.body as ProductCreateResult)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ManageCreatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageCreatePost$Json$Response(params?: {
    body?: ProductCreateModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductCreateResult>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ManageCreatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductCreateResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ManageCreatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageCreatePost$Json(params?: {
    body?: ProductCreateModel
  },
  context?: HttpContext

): Observable<ProductCreateResult> {

    return this.v1ManageCreatePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductCreateResult>) => r.body as ProductCreateResult)
    );
  }

  /**
   * Path part for operation v1ManageUpdatePost
   */
  static readonly V1ManageUpdatePostPath = '/v1/manage/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ManageUpdatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageUpdatePost$Plain$Response(params?: {
    body?: ProductUpdateModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductUpdateResult>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ManageUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductUpdateResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ManageUpdatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageUpdatePost$Plain(params?: {
    body?: ProductUpdateModel
  },
  context?: HttpContext

): Observable<ProductUpdateResult> {

    return this.v1ManageUpdatePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductUpdateResult>) => r.body as ProductUpdateResult)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ManageUpdatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageUpdatePost$Json$Response(params?: {
    body?: ProductUpdateModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductUpdateResult>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ManageUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductUpdateResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ManageUpdatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageUpdatePost$Json(params?: {
    body?: ProductUpdateModel
  },
  context?: HttpContext

): Observable<ProductUpdateResult> {

    return this.v1ManageUpdatePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductUpdateResult>) => r.body as ProductUpdateResult)
    );
  }

  /**
   * Path part for operation v1ManageStatusUpdatePost
   */
  static readonly V1ManageStatusUpdatePostPath = '/v1/manage/status/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ManageStatusUpdatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageStatusUpdatePost$Plain$Response(params?: {
    body?: ProductStatusUpdateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductStatusUpdateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ManageStatusUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductStatusUpdateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ManageStatusUpdatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageStatusUpdatePost$Plain(params?: {
    body?: ProductStatusUpdateRequest
  },
  context?: HttpContext

): Observable<ProductStatusUpdateResponse> {

    return this.v1ManageStatusUpdatePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductStatusUpdateResponse>) => r.body as ProductStatusUpdateResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ManageStatusUpdatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageStatusUpdatePost$Json$Response(params?: {
    body?: ProductStatusUpdateRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProductStatusUpdateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IndexService.V1ManageStatusUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductStatusUpdateResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ManageStatusUpdatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ManageStatusUpdatePost$Json(params?: {
    body?: ProductStatusUpdateRequest
  },
  context?: HttpContext

): Observable<ProductStatusUpdateResponse> {

    return this.v1ManageStatusUpdatePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProductStatusUpdateResponse>) => r.body as ProductStatusUpdateResponse)
    );
  }

}
